import React, { useState, useEffect } from 'react';
import { superAdminDashboard } from '../../CommonAPI/SuperAdmin'
import Loader from '../../../ExtraComponent/Loader';
import Content from "../../../ExtraComponent/Content";


const Dashboards = () => {
    const [dashData, setData] = useState([]);

    useEffect(() => {
        SuperAdminDashboardData();
    }, []);

    const SuperAdminDashboardData = async () => {
        await superAdminDashboard()
            .then((response) => {
                if (response.Status) {
                    setData(response.Data)
                }
                else {
                    setData([])
                }
            })
            .catch((err) => {
                console.log("Error in fatching the Dashboard Details", err)
            })
    };



    return (
<Content>
  <div>
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb iq-bg-primary">
        <li className="breadcrumb-item active" aria-current="page">
          Dashboard
        </li>
      </ol>
    </nav>

    {dashData?.length === 0 ? (
      <Loader />
    ) : (
      <div className="container-fluid mt-4">
        <div className="row g-4">
          {/* Total Account */}
          <div className="col-lg-4 col-md-6">
            <div className="iq-card dashboard-card border-top-blue">
              <div className="iq-card-header pb-0">
                <h5 className="card-title">Total Account</h5>
              </div>
              <div className="iq-card-body">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <span className="card-label">Total:</span>
                  <span className="card-value">{dashData?.[0]?.['Total account']}</span>
                </div>
                <div className="progress rounded-pill" style={{ height: "8px" }}>
                  <div className="progress-bar bg-primary" style={{ width: "70%" }}></div>
                </div>
              </div>
            </div>
          </div>

          {/* Total On Account */}
          <div className="col-lg-4 col-md-6">
            <div className="iq-card dashboard-card border-top-green">
              <div className="iq-card-header pb-0">
                <h5 className="card-title">Total On Account</h5>
              </div>
              <div className="iq-card-body">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <span className="card-label">Active:</span>
                  <span className="card-value">{dashData?.[0]?.['Total On account']}</span>
                </div>
                <div className="progress rounded-pill" style={{ height: "8px" }}>
                  <div className="progress-bar bg-success" style={{ width: "60%" }}></div>
                </div>
              </div>
            </div>
          </div>

          {/* Total Off Account */}
          <div className="col-lg-4 col-md-6">
            <div className="iq-card dashboard-card border-top-red">
              <div className="iq-card-header pb-0">
                <h5 className="card-title">Total Off Account</h5>
              </div>
              <div className="iq-card-body">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <span className="card-label">Expired:</span>
                  <span className="card-value">{dashData?.[0]?.['Total Off account']}</span>
                </div>
                <div className="progress rounded-pill" style={{ height: "8px" }}>
                  <div className="progress-bar bg-danger" style={{ width: "40%" }}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )}
  </div>
</Content>



    )
}

export default Dashboards
